import React from "react";
import { translations } from "../translations";

const ClockIcon = () => (  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
    <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
);

const ListIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="4" y="5" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.75" />
    <path d="M8 9h8M8 13h5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
);

const StartScreen = ({ lang, questionLimit, onStart }) => {
  const t = translations[lang];
  const count = Number(questionLimit) || 10;

  const details = [
    {
      icon: ClockIcon,
      label: t.duration,
      value: t.estimatedTime,
    },
    {
      icon: ListIcon,
      label: t.questionsLabel,
      value: t.randomQuestionsInfo.replace("{count}", String(count)),
    },
  ];
  return (
    <div className="page-wrap">
      <div className="landing-card">
        <header className="landing-header">
          <div className="landing-header-pattern" aria-hidden="true" />
          <div className="landing-header-content">
            <div className="landing-logo-wrap">
              <img src="/logo.png" alt="HevMed Medicals" className="landing-logo" />
            </div>
            <div className="landing-header-copy">
              <span className="landing-badge">
                <span className="landing-badge-dot" />
                {t.medicalAssessment}
              </span>
              <h1 className="landing-title">{t.title}</h1>
              <p className="landing-subtitle">{t.welcome}</p>
            </div>
          </div>
        </header>

        <div className="landing-main">
          <ul className="landing-details landing-details-two">
            {details.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.label} className="landing-detail">
                  <span className="landing-detail-icon">
                    <Icon />
                  </span>
                  <div className="landing-detail-copy">
                    <span className="landing-detail-label">{item.label}</span>
                    <span className="landing-detail-value">{item.value}</span>
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="landing-callout">
            <p>{t.introText}</p>
          </div>

          <button type="button" className="landing-cta" onClick={onStart}>
            <span>{t.startInterview}</span>
            <span className="landing-cta-arrow" aria-hidden="true">→</span>
          </button>

          <p className="landing-footer">© {new Date().getFullYear()} HevMed Medicals. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default StartScreen;
